import { ProtectedRoute } from "@/entities/session";
import { administrationRouter } from "@/pages/administration/router";
import { authRouter } from "@/pages/auth/router";
import { droolsEditorRouter } from "@/pages/drools-editor/router";
import { NotFoundPage } from "@/pages/errors/NotFoundPage";
import { errorsRouter } from "@/pages/errors/router";
import { homeRouter } from "@/pages/home/router";
import { organizationsRouter } from "@/pages/organizations/router";
import { virtualDevicesRouter } from "@/pages/virtual-devices/router";
import { routePaths } from "@/shared/config/routePaths";
import { Navigate, RouteObject } from "react-router-dom";
import { Layout } from "./layout/Layout";

export const routes: RouteObject[] = [
    authRouter,
    {
        path: '/',
        element: (
            <ProtectedRoute>
                <Layout />
            </ProtectedRoute>),
        children: [
            homeRouter,
            { index: true, element: <Navigate to={routePaths.home} replace /> },
            administrationRouter,
            organizationsRouter,
            virtualDevicesRouter,
            droolsEditorRouter,
            ...errorsRouter,
        ]
    },
    { path: '*', element: <NotFoundPage /> }
];
